export const VERSION = '10.0.0';
//# sourceMappingURL=pkg-version.js.map